import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ConfigService } from '../../../core/utils/config-service';

@Component({
    selector: 'app-personal-list',
    templateUrl: './personal-list.component.html',
    imports: [CommonModule,],
    styleUrls: ['./personal-list.component.css']
})
export class PersonalListComponent {
  @Input('vue') vue:any="list"
  @Input('datas') datas:any[]=[]
  basePath=ConfigService.toFile('storage/personals/')
}
